import { render, staticRenderFns } from "./view-item-custom.vue?vue&type=template&id=981d29be&"
import script from "./view-item-custom.vue?vue&type=script&lang=js&"
export * from "./view-item-custom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports